export default "/_next/static/images/magic-line-6-0864dd6baa3fbdc44c23ffe3327b8c0b.svg";